/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {List} from 'immutable';
import CloseButton from '../../../components/buttons/CloseButton';
import ArrLeftButton from '../../../components/buttons/ArrLeftButton';
import ArrRightButton from '../../../components/buttons/ArrRightButton';
import {
    fetchBarReportShiftsBarmans, changeShiftBarman, openBarReportBarmansPopup
} from '../../../../common/menu/report/shifts/actions';

class BarmansPopup extends React.Component {

    state: State = {
        page: 0
    };

    static propTypes = {
        msg: React.PropTypes.object,
        shift: React.PropTypes.object,
        barmans: React.PropTypes.object,
        fetchBarReportShiftsBarmans: React.PropTypes.func,
        barId: React.PropTypes.number,
        openBarReportBarmansPopup: React.PropTypes.func,
        changeShiftBarman: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.changeBarman = this.changeBarman.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
    }

    prevPage() {
        const {page} = this.state;
        if (page - 1 < 0) {
            this.setState({page: 0});
        } else {
            this.setState({page: page - 1});
        }
    }

    nextPage() {
        const {page} = this.state;
        this.setState({page: page + 1});
    }

    changeBarman(barmanId) {
        const {shift, changeShiftBarman, openBarReportBarmansPopup} = this.props;
        changeShiftBarman(shift.get('id'), barmanId);
        openBarReportBarmansPopup(false);
    }

    componentWillMount() {
        const {fetchBarReportShiftsBarmans, barId} = this.props;
        fetchBarReportShiftsBarmans(barId);
    }

    render() {
        const {barmans, openBarReportBarmansPopup, msg} = this.props;
        const {page} = this.state;
        const limit = 63;
        const max = !!barmans ? barmans.size : 0;
        const from = page * limit;
        const to = from + limit;
        let barmansToRender = List();
        if (!!barmans) {
            barmans.forEach((b, i) => {
                if (i >= from && i < to) {
                    barmansToRender = barmansToRender.push(b);
                }
            });
        }

        return (
            <div id="bills-list" className="pageTables with-header barmans">
                <div className="pageTables-controls view-top">
                  <div className="pageTables-controls-title" style={{width: '66.66%'}}>
                    <div className="pageTables-title">
                        {msg.shifts.barmanSelect}
                    </div>
                  </div>
                  <div className="pageTables-controls-key">
                    <div className={`boxBtn color-white ${page < 1 ? 'disabled' : ''}`}
                         onClick={() => this.prevPage()}>
                        <ArrLeftButton/>
                    </div>
                  </div>
                  <div className="pageTables-controls-key">
                    <div
                        className={`boxBtn color-white ${max <= limit || page === (Math.ceil(max / limit) - 1) ? 'disabled' : ''}`}
                        onClick={() => this.nextPage()}>
                        <ArrRightButton/>
                    </div>
                  </div>
                  <div className="pageTables-controls-key">
                    <div className="boxBtn color-white"
                         onClick={() => openBarReportBarmansPopup(false)}>
                        <CloseButton/>
                    </div>
                  </div>
                </div>
                {barmansToRender.map(b =>
                  <div key={`barman-${b.get('id')}`} className="pageTables-key">
                    <div
                         onClick={() => this.changeBarman(b.get('id'))}
                         className={`boxBtn color-greenLight`}>
                        <div className="boxBtn-inner">
                            <span>
                                {b.get('fullName')}
                            </span>
                        </div>
                    </div>
                  </div>
                )}
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    barId: state.bars.getIn(['bar', 'id']),
    barmans: state.shifts.get('barmans'),
    shift: state.shifts.get('shift')
}), {fetchBarReportShiftsBarmans, openBarReportBarmansPopup, changeShiftBarman})(BarmansPopup);



// WEBPACK FOOTER //
// ./src/browser/menu/report/shifts/BarmansPopup.js